// import React from 'react'
// import { FaPlus } from "react-icons/fa6";
// import {
//   MDBCol,
//   MDBRow
// } from "mdb-react-ui-kit";
// import { PiBooksThin } from "react-icons/pi";
// import { GiDiscussion } from 'react-icons/gi'
// import { CiTimer } from "react-icons/ci";
// import { PiStudentLight } from "react-icons/pi";
// import { PiUsersThreeThin } from "react-icons/pi";


// function Total_Count({ interval }) {
    
//     return (
//       <div className='mt-5'>
//         {/* ---------------------------Mobile View------------------------- */}
//         <div className='d-sm-block pb-2 pt-4 d-md-none total_count_background'>
//         <div className='container'>
//           <MDBRow className="d-flex justify-content-center">
//           <MDBCol md="10" xl="8" className="text-center total_component_text">
//               <h2 className="display-5">Success Stats</h2>
//               <p className=" pt-2">Get to the heart of what it takes to succeed by digging into our varied courses, many hours of instruction, happy students, seasoned teachers, and solid networks of contacts at top employers. Get involved with our vibrant group!</p>
//           </MDBCol>
//           </MDBRow>
//           <div class="container">
//           <div className='row'>
//           <div class="col-6">
//               <div className='text-center'>
//               <h2 className="mobile_Total_num" data-val="40">40<FaPlus size="30px" color="black" /></h2>
//               <p className="Total_text">Programs</p>
//               </div>
//           </div>
//           <div class="col-6">
//               <div className='text-center'>
//               <h2 className="mobile_Total_num" data-val="100">10K<FaPlus size="30px" color="black" /></h2>
//               <p className="Total_text">Hours</p>
//               </div>
//           </div>
//           <div class="col-6">
//               <div className='text-center'>
//               <h2 className="mobile_Total_num" data-val="50">50<FaPlus size="30px" color="black" /></h2>
//               <p className="Total_text">Mentors</p>
//               </div>
//           </div>
//           <div class="col-6">
//               <div className='text-center'>
//               <h2 className="mobile_Total_num" data-val="100">100<FaPlus size="30px" color="black" /></h2>
//               <p className="Total_text">Recruiters</p>
//               </div>
//           </div>
//           <div class="col-12">
//               <div className='text-center'>
//               <h2 className="mobile_Total_num" data-val="10">50K<FaPlus size="30px" color="black" /></h2>
//               <p className="Total_text">Students</p>
//               </div>
//           </div>
//           </div>
//           </div>
//           </div>
//         </div>

//         {/* ---------------------------Dasktop View------------------------- */}
//         <div className='d-none d-md-block total_count_background'>
//         <div className='container'>
//           <MDBRow className="d-flex justify-content-center">
//           <MDBCol md="10" xl="8" className="text-center pt-4 total_component_text">
//               <h2 className="display-5">Success Stats</h2>
//               <p className="px-4">Get to the heart of what it takes to succeed by digging into our varied courses, many hours of instruction, happy students, seasoned teachers, and solid networks of contacts at top employers. Get involved with our vibrant group!</p>
//           </MDBCol>
//           </MDBRow>
//           <div class="pb-4 pt-3 container">
//           <div className='row'>
//           <div className='d-flex justify-content-evenly'>
//           <div class="">
//               <div className='text-center'>
//               <PiBooksThin size="50px" color="black" />
//               <h2 className="pt-2 Total_num" data-val="40">40<FaPlus size="35px" color="black" /></h2>
//               <p className="Total_text">Programs</p>
//               </div>
//           </div>
//           <div class="">
//               <div className='text-center'>
//               <CiTimer size="50px" color="black" />
//               <h2 className="Total_num pt-2" data-val="100">10K<FaPlus size="35px" color="black" /></h2>
//               <p className="Total_text">Hours</p>
//               </div>
//           </div>
//           <div class="">
//               <div className='text-center'>
//               <PiUsersThreeThin size="50px" color="black" />
//               <h2 className="Total_num pt-2" data-val="50">50<FaPlus size="35px" color="black" /></h2>
//               <p className="Total_text">Mentors</p>
//               </div>
//           </div>
//           <div class="">
//               <div className='text-center'>
//               <GiDiscussion size="50px" color="black" />
//               <h2 className="Total_num pt-2" data-val="100">100<FaPlus size="35px" color="black" /></h2>
//               <p className="Total_text">Recruiters</p>
//               </div>
//           </div>
//           <div class="">
//               <div className='text-center'>
//               <PiStudentLight size="50px" color="black" />
//               <h2 className="Total_num pt-2" data-val="10">50K<FaPlus size="35px" color="black" /></h2>
//               <p className="Total_text">Students</p>
//               </div>
//           </div>
//           </div>
//           </div>
//           </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
  
//   export default Total_Count;


import React, { useEffect, useRef, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { PiBooksThin } from "react-icons/pi";
import { GiDiscussion } from "react-icons/gi";
import { CiTimer } from "react-icons/ci";
import { PiStudentLight, PiUsersThreeThin } from "react-icons/pi";

const statsData = [
  { id: 1, label: "Programs", value: 40, icon: <PiBooksThin size="50px" color="black" /> },
  { id: 2, label: "Hours", value: 10000, icon: <CiTimer size="50px" color="black" /> },
  { id: 3, label: "Mentors", value: 50, icon: <PiUsersThreeThin size="50px" color="black" /> },
  { id: 4, label: "Recruiters", value: 10000, icon: <GiDiscussion size="50px" color="black" /> },
  { id: 5, label: "Students", value: 100000, icon: <PiStudentLight size="50px" color="black" /> },
];

const formatNumber = (num) => {
  return num >= 1000 ? Math.floor(num / 1000) + "K" : num;
};

function Total_Count() {
  const [hasAnimated, setHasAnimated] = useState(false);
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          startCounting();
          setHasAnimated(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  const startCounting = () => {
    statsData.forEach((stat, index) => {
      let start = 0;
      const end = stat.value;

      
      const duration = 2500;
      const steps = end >= 1000 ? end / 1000 : end; 
      const increment = end >= 1000 ? 1000 : 1;     
      const intervalTime = duration / steps;

      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(timer);
        }

        setCounts((prev) => {
          const updated = [...prev];
          updated[index] = start;
          return updated;
        });
      }, intervalTime);
    });
  };

  return (
    <div className="mt-5" ref={sectionRef}>
      {/* ---------------------- Mobile View ---------------------- */}
      <div className="d-sm-block pb-2 pt-4 d-md-none total_count_background">
        <div className="container">
          <MDBRow className="d-flex justify-content-center">
            <MDBCol md="10" xl="8" className="text-center total_component_text">
              <h2 className="display-5">Success Stats</h2>
              <p className="pt-2">
                Get to the heart of what it takes to succeed by digging into our
                varied courses, many hours of instruction, happy students,
                seasoned teachers, and solid networks of contacts at top
                employers. Get involved with our vibrant group!
              </p>
            </MDBCol>
          </MDBRow>

          <div className="container">
            <div className="row">
              {statsData.map((stat, i) => (
                <div
                  className={`col-6 ${stat.id === 5 ? "col-12" : ""}`}
                  key={stat.id}
                >
                  <div className="text-center">
                    <h2 className="mobile_Total_num">
                      {formatNumber(counts[i])}
                      <FaPlus size="25px" color="black" />
                    </h2>
                    <p className="Total_text">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------- Desktop View ---------------------- */}
      <div className="d-none d-md-block total_count_background">
        <div className="container">
          <MDBRow className="d-flex justify-content-center">
            <MDBCol
              md="10"
              xl="8"
              className="text-center pt-4 total_component_text"
            >
              <h2 className="display-5">Success Stats</h2>
              <p className="px-4">
                Get to the heart of what it takes to succeed by digging into our
                varied courses, many hours of instruction, happy students,
                seasoned teachers, and solid networks of contacts at top
                employers. Get involved with our vibrant group!
              </p>
            </MDBCol>
          </MDBRow>

          <div className="pb-4 pt-3 container">
            <div className="d-flex justify-content-evenly flex-wrap gap-4">
              {statsData.map((stat, i) => (
                <div key={stat.id} className="text-center">
                  {stat.icon}
                  <h2 className="pt-2 Total_num">
                    {formatNumber(counts[i])}
                    <FaPlus size="30px" color="black" />
                  </h2>
                  <p className="Total_text">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Total_Count;
